/*
* @Author: yongwenhao
* @Date: 2020-04-09 16:17:59
* @describe: 公司新闻
*/
<template>
	<div class="company">
		<Banner :bannerContent="bannerContent"></Banner>
		<ItemWarp :dataList="dataList" :loading="loading" :title="bannerContent.title" @onScrollBottom="onScrollBottom"></ItemWarp>
	</div>
</template>

<script>
import Banner from './components/banner'
import ItemWarp from './components/item-wrapper'
import { GetNewList } from '../../api/web'

import {handleNewsData} from '../../js/common'

export default {
	name: 'company',
	components: { Banner, ItemWarp },
	data() {
		this._params = {
			companyId: 2,
			pageNum: 1,
			pageSize: 10,
			newsType: 0,
		}
		this.total = 0
		return {
			bannerContent: {
				src: require('../../assets/news_banner.png'),
				title: this.$t('menu.company'),
			},
			dataList: [],
			loading: false,
		}
	},
	methods: {
		init() {
			GetNewList(this._params).then((res) => {
				if (res.status) {
					// this.dataList = handleNewsData(res.data.dataList)
          this.dataList.push(...res.data.dataList);
					this.loading = false
					this.total = res.data.total
				}
			})
		},
		onScrollBottom() {
			if (this.loading || this.dataList.length >= this.total) return
			this._params.pageNum++
			this.loading = true
			this.init()
		},
	},
	created() {
		this.init()
	},
}
</script>

<style lang='less' scoped>
//@import url($3); 引入公共css类
</style>